export default `/* Ids Toast Component */
.ids-toast .hidden {
  display: none;
}
.ids-toast .toast-container {
  display: inline-block;
  position: fixed;
  max-width: 60%;
  z-index: var(--ids-z-index-toast);
}
.ids-toast .toast-container.bottom-end {
  bottom: var(--ids-space-xs);
  right: var(--ids-space-xs);
}
.ids-toast .toast-container.bottom-start {
  bottom: var(--ids-space-xs);
  left: var(--ids-space-xs);
}
.ids-toast .toast-container.top-end {
  top: var(--ids-space-xs);
  right: var(--ids-space-xs);
}
.ids-toast .toast-container.top-start {
  top: var(--ids-space-xs);
  left: var(--ids-space-xs);
}

:host([dir=rtl]) .toast-container.bottom-end {
  left: var(--ids-space-xs);
  right: unset;
}
:host([dir=rtl]) .toast-container.bottom-start {
  left: unset;
  right: var(--ids-space-xs);
}
:host([dir=rtl]) .toast-container.top-end {
  left: var(--ids-space-xs);
  right: unset;
}
:host([dir=rtl]) .toast-container.top-start {
  left: unset;
  right: var(--ids-space-xs);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdG9hc3QiLCJzb3VyY2VzIjpbImlkcy10b2FzdC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBRUU7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTs7O0FBT0Y7RUFDRTtFQUNBOztBQUdGO0VBQ0U7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIFRvYXN0IENvbXBvbmVudCAqL1xuLmlkcy10b2FzdCB7XG4gIC5oaWRkZW4ge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cblxuICAudG9hc3QtY29udGFpbmVyIHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgcG9zaXRpb246IGZpeGVkO1xuICAgIG1heC13aWR0aDogNjAlO1xuICAgIHotaW5kZXg6IHZhcigtLWlkcy16LWluZGV4LXRvYXN0KTtcblxuICAgICYuYm90dG9tLWVuZCB7XG4gICAgICBib3R0b206IHZhcigtLWlkcy1zcGFjZS14cyk7XG4gICAgICByaWdodDogdmFyKC0taWRzLXNwYWNlLXhzKTtcbiAgICB9XG5cbiAgICAmLmJvdHRvbS1zdGFydCB7XG4gICAgICBib3R0b206IHZhcigtLWlkcy1zcGFjZS14cyk7XG4gICAgICBsZWZ0OiB2YXIoLS1pZHMtc3BhY2UteHMpO1xuICAgIH1cblxuICAgICYudG9wLWVuZCB7XG4gICAgICB0b3A6IHZhcigtLWlkcy1zcGFjZS14cyk7XG4gICAgICByaWdodDogdmFyKC0taWRzLXNwYWNlLXhzKTtcbiAgICB9XG5cbiAgICAmLnRvcC1zdGFydCB7XG4gICAgICB0b3A6IHZhcigtLWlkcy1zcGFjZS14cyk7XG4gICAgICBsZWZ0OiB2YXIoLS1pZHMtc3BhY2UteHMpO1xuICAgIH1cbiAgfVxufVxuXG46aG9zdChbZGlyPSdydGwnXSkge1xuICAudG9hc3QtY29udGFpbmVyIHtcbiAgICAmLmJvdHRvbS1lbmQge1xuICAgICAgbGVmdDogdmFyKC0taWRzLXNwYWNlLXhzKTtcbiAgICAgIHJpZ2h0OiB1bnNldDtcbiAgICB9XG5cbiAgICAmLmJvdHRvbS1zdGFydCB7XG4gICAgICBsZWZ0OiB1bnNldDtcbiAgICAgIHJpZ2h0OiB2YXIoLS1pZHMtc3BhY2UteHMpO1xuICAgIH1cblxuICAgICYudG9wLWVuZCB7XG4gICAgICBsZWZ0OiB2YXIoLS1pZHMtc3BhY2UteHMpO1xuICAgICAgcmlnaHQ6IHVuc2V0O1xuICAgIH1cblxuICAgICYudG9wLXN0YXJ0IHtcbiAgICAgIGxlZnQ6IHVuc2V0O1xuICAgICAgcmlnaHQ6IHZhcigtLWlkcy1zcGFjZS14cyk7XG4gICAgfVxuICB9XG59XG4iXX0= */`;
